import React from 'react'
import style from './about.module.scss'
import { VegaButton, VegaButtonTypes } from '../vega/button/Button'
import { VegaHeading } from '../vega/heading/Heading'
import { useTranslation } from 'react-i18next'

/**
 * About section of the payment tracker
 */
const About = () => {
	const { t } = useTranslation()
	return (
		<div className={style.about}>
			<div className={style.container}>
				<div className={style.left}>
					<VegaHeading className={style.h2} tag={'h2'} label={t('footerPromptTitle')} />
					<VegaHeading
						className={style.h3}
						tag={'h3'}
						label={t('footerPromptSubtitle')}
					/>
				</div>
				<VegaButton
					type={VegaButtonTypes.SECONDARY}
					label={t('footerGetintouch')}
					onClick={() => window.open(t('footerGetintouchHref'))}
				/>
			</div>
		</div>
	)
}

About.propTypes = {}

export { About }
